export const SETKITLIST = "SETKITLIST";
export const SETITEMSLIST = "SETITEMSLIST";
export const SETITEMSINKIT = "SETITEMSINKIT";
export const SETUSERSINKIT = "SETUSERSINKIT";
export const CLEARDOC = "CLEARDOC";
export const SETKITITEM = "SETKITITEM";
export const SETKITSETTINGS = "SETKITSETTINGS";
export const SETKITBASICFILTERDATA = "SETKITBASICFILTERDATA";